import React from 'react';

import './ContactLensButtons.scss';

export const ContactLensButtons = props => {
  const { isFixedBottom } = props;

  return (
    <div className="contact-lens-buttons" data-is-fixed-bottom={isFixedBottom}>
      <div className="contact-lens-buttons__container">
        <a data-key="add-to-cart" href="/sg/en/mockup/contact-lens-cart">
          <span>ADD TO CART</span>
        </a>
        <a data-key="try-it-for-free" href="#">
          <span>TRY IT FOR FREE</span>
        </a>
      </div>
    </div>
  );
};
